import { BASE_ADMIN_V2_PATH } from '../../shared/admin/constants/path.constants';

const ADMIN_DELIVERY_CITIES_APP_ROOT = `${BASE_ADMIN_V2_PATH}/delivery-cities`;

export const ADMIN_DELIVERY_CITIES_APP_PATHS = {
  DELIVERY_CITIES_LIST: `${ADMIN_DELIVERY_CITIES_APP_ROOT}`,
  DELIVERY_CITY_DETAILS: `${ADMIN_DELIVERY_CITIES_APP_ROOT}/:deliveryCityId`,
  DELIVERY_CITY_DETAILS_PATH: (deliveryCityId: string) => `${ADMIN_DELIVERY_CITIES_APP_ROOT}/${deliveryCityId}`,
};
